import { editorContextStore } from "@/contexts/editor-context";
import { UiDisplayMessageDialogEventHandler } from "@/core/common/types";

const creditDenialPattern = /quota left|not enough (prediction )?credits|requires a paid plan/i;

// The server decides allowance, so its denial is the first point the client can offer an upgrade.
export function showQuotaDialogOnDenial(denial: unknown) {
  const { code, message } = (denial ?? {}) as { code?: unknown; message?: unknown };
  if (
    code !== "functions/resource-exhausted" &&
    !(typeof message === "string" && creditDenialPattern.test(message))
  ) {
    return;
  }
  editorContextStore
    .getState()
    .eventEmitter.emit<UiDisplayMessageDialogEventHandler>(
      "ui:display-message-dialog",
      "quota-subscribe",
      {
        title: "No image generation credits left.",
        header: "You have used all image generation credits. Please upgrade your plan to continue.",
      },
    );
}
